<template>
  <div class="finance-biz-bd tb" v-if="funcView.financeBizReport_list">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.financeBizReport_export">
          <el-button class="table-set" @click="exportTable" :disabled="exporting">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('report_financeBiz.htbhsghth')" v-model="formSearch.keyword" @fetch="getTableList"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-form-item style="float: right" v-if="funcView.financeBizReport_refresh">
          <el-button @click="onRefresh()" :disabled="asyncing">
            <i class="icon icon-shuaxin"></i>
            {{funcView.financeBizReport_refresh}}
            <span v-if="asyncing">（{{ $t('report_financeBiz.shua_xin_zhong') }}... ）</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 更多筛选 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('report_financeBiz.she_bei_lei_xing')">
          <custom-select v-model="formSearch.deviceBizType" code="dms_device_biz_type" :props="{ label: 'name', value: 'value' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_financeBiz.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_financeBiz.dai_li_gong_si')">
          <custom-select url="partnerSelectAgent" :props="{ label: 'label', value: 'value' }" v-model="formSearch.agentCoId" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_financeBiz.zu_lin_fang')">
          <custom-select url="partnerGetCustomerList" :props="{ label: 'partnerName', value: 'partnerOrgId' }" :params="{num:50}" v-model="formSearch.customerId" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_financeBiz.qi_zu_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.rentalStartTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss" size="small"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_financeBiz.fu_kuan_fang')">
          <el-input style="width: 100%" v-model="formSearch.payableOrgName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_financeBiz.shou_kuan_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.billReceivedTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_financeBiz.kai_piao_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.invoiceTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('report_financeBiz.fa_piao_hao_ma')">
          <el-input v-model="formSearch.invoiceNum" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="progress" v-if="asyncing">
      <p>{{ $t('report_financeBiz.sjsxjd') }}</p>
      <el-progress :percentage="percentage" color="#0D9AE0"></el-progress>
    </div>
    <div class="table-bd">
      <custom-table index  :data="tableList" tableCode="financeBiz"  @column="getColumn" @filter="filterChange" @sort="sortChange" height="100%"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import qs from 'qs';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'financeBiz',
  mixins: [resetFormSearchMixins],
  computed: {
    percentage() {
      const num = this.remain > 0 && this.totalTasks - this.remain > 0 ? this.totalTasks - this.remain : 0;
      return (Math.round(num / this.totalTasks * 100))||0;
    },
    bizType() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.bizType : '';
    },
  },
  data() {
    return {
      dateTimes: [],
      formSearch: {
        keyword: '',
        deviceBizType: '',
        productCode: '',
        agentCoId: '',
        customerId: '',
        rentalStartTime: [],
        payableOrgName: '',
        billReceivedTime: [],
        invoiceTime: [],
        invoiceNum: '',
        pageNum: 1,
        pageSize: 50,
        orgType: ''
      },
      exporting: false,
      asyncing: false,
      timer: null,
      totalTasks: 0,
      remain: 0,
      tableList: [],
      totalRows: 0,
      link: null,
    };
  },
  mounted: function () {
    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  methods: {
    getColumn(table) {
      this.tableColumn = table.tableColumn;
      this.setColumn(table);
    },
    getTableList() {
      this.formSearch.orgType = this.bizType;
      this.$getJSON(apis.reportFinanceBiz, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 刷新报表
    onRefresh: function () {
      let refreshApi = '';
      let progressApi = '';
      // 刷新报表
      refreshApi = apis.reportFinanceBizRefresh;
      progressApi = apis.reportFinanceBizRefreshProgress;
      this.$getJSON(refreshApi, this.formSearch).then((res) => {
        this.totalTasks = res.data;
        this.asyncing = true;
        this.timer = setInterval(() => {
          this.$getJSON(progressApi).then((progress) => {
            this.remain = progress.data;
            if (this.remain < 1) {
              clearInterval(this.timer);
              this.timer = null;
              this.remain = 0;
              this.asyncing = false;
              this.onPageChange({ page: 1 });
            }
          });
        }, 5000);
      });
    },
    // 导出
    exportTable: function () {
      const param = {};
      Object.keys(this.formSearch).forEach((key) => {
        const val = this.formSearch[key];
        if (val) {
          param[key] = val;
        }
      });
      delete param.pageSize;
      delete param.pageNum;
      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });
      const headerList = this.tableColumn.filter(t => t.isExport).map(i => ({ columnCode: i.columnCode, columnName: i.columnName, width: i.width, isFormat: i.isFormat, formatRule: i.formatRule, dicGroup: i.dicGroup }));
      const reqData = {
        exportName: this.$t('report_financeBiz.cai_wu_bao_biao'),
        headerList: headerList,
      };
      this.exporting = true;
      this.$exportFliePost(`${apis.reportFinanceBizExport}?${pathParms}`, reqData)
        .then(() => {
          this.exporting = false;
        })
        .catch(() => {
          this.exporting = false;
          this.$message.error(this.$t('report_financeBiz.dao_chu_shi_bai'));
        });
    },
  },
};
</script>

<style lang="scss"></style>
